import React, { useEffect } from "react";
import { useTransactModel } from "./transactModel";
import { Button, message, Steps } from "antd";
import { YhBox } from "@/components/YhBox";
import { TransactDataTable } from "./DataTable";
import { TransactDrawer } from "./TransactDrawer";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";

export const TransactDataBox = () => {
    const {
        dataSource,
        selectedData,
        selectedRowKeys,
        setTransactDrawerVisible,
        loadData,
        setSelectedData,
        writeoffAmount,
    } = useTransactModel();

    useEffect(() => {
        loadData({ pageNum: 1 })
    }, [])

    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedData(selectedData)
    }, [selectedRowKeys]);


    const onApproval = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            if (selectedData?.status === 1) {
                setTransactDrawerVisible(true);
            } else {
                message.error("该条记录不可审核!");
            }
        } else {
            message.error("请选择待审核记录!");
        }
    }

    // const action = (
    //     <YhAuth resCode={ResourceAuthEnum.ACC_C_VW_ADJ_AUDIT}>
    //         <Button
    //             className="mr-5"
    //             type="link"
    //             shape="round"
    //             onClick={onApproval}
    //         >
    //             审核
    //         </Button>
    //     </YhAuth>
    // );

    const desc: IDescription[] = [
        {
            label: "核销总额",
            value: writeoffAmount?.toFixed(2) ?? '0.00',
            color: DescriptionColorEnum.green
        },
    ]



    return (
        <>
            <YhBox title={"核销记录"} descriptions={desc}>
                <TransactDataTable />
            </YhBox>
            <TransactDrawer />
        </>
    )
}
